export const isObj = (obj) => typeof obj === "object" && !Array.isArray(obj) && obj !== null;
export const removeDuplicateObjectsByProperty = (arr, prop) => {
	return arr.filter((obj, index, self) =>
	  index === self.findIndex((o) => o[prop] === obj[prop])
	);
}